import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PointAccountTargetType } from '@/models/point-account.model';
import { getRunningClub } from '@/services/running-club.service';
import { getRunningClubEvent } from '@/services/running-club-event.service';
import { getEnergyHub } from '@/services/energy-hub.service';

interface Props {
  targetType: PointAccountTargetType;
  targetId: number;
}

/** Resolves an assignment target id to a linked club / event name. */
const AssignmentTargetName: React.FC<Props> = ({ targetType, targetId }) => {
  const [name, setName] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (targetType == PointAccountTargetType.Platform) return;
    let cancelled = false;
    const load = targetType == PointAccountTargetType.RunningClub
      ? getRunningClub(targetId).then(r => r.result?.name)
      : targetType == PointAccountTargetType.EnergyHub
        ? getEnergyHub(targetId).then(r => r.result?.name)
        : getRunningClubEvent(targetId).then(r => r.result?.name);
    load.then(n => { if (!cancelled) setName(n); }).catch(() => { if (!cancelled) setName(undefined); });
    return () => { cancelled = true; };
  }, [targetType, targetId]);

  if (targetType == PointAccountTargetType.Platform) return <span>All users (app-wide)</span>;

  const to = targetType == PointAccountTargetType.RunningClub
    ? `/running-clubs/${targetId}`
    : targetType == PointAccountTargetType.EnergyHub
      ? `/energy-hubs/${targetId}`
      : `/running-clubs/events/${targetId}`;

  return <Link to={to}>{name ?? `#${targetId}`}</Link>;
};

export default AssignmentTargetName;
